export const LOCATION_IDS = {
  HOME: 'home',
  POND: 'pond',
  MARKET: 'market',
  RIVER: 'river',
  LAKE: 'lake',
  COAST: 'coast',
  DEEP_SEA: 'deep_sea',
  ARCTIC: 'arctic',
} as const;

export const FISH_XP_BASE = 10;
export const FISH_XP_PER_TIER = 10;
export const SELL_XP = 5;
